module.exports = __webpack_public_path__ + "img/2.fc2ea898.jpeg";